import { Box, Collapse, Icon, Stack, Text } from '@chakra-ui/core'
import { getAvatarSrc } from 'components/Tasks/utils'
import { Button } from 'components/ui'
import useLocaleText from 'components/useLocaleText'
import colors from 'constants/colors'
import { RootState } from 'constants/interfaces'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import ContextInfo from 'components/TasksV2/UI/ContextInfo'
import { getContextName } from 'hooks/useContextName'

interface IProps {
  participants: {
    id: string
    date?: string
    isClickable?: boolean
    insights?: {
      items: any[]
      typeCounts: {
        [type: number]: number
      }
    }
  }[]
}

export const VotedParticipants = ({ participants }: IProps) => {
  const { groups } = useSelector((state: RootState) => state.config.config)
  const { retailUsersObject } = useSelector((state: RootState) => state.config.config)
  const [showAll, setShowAll] = useState(false)
  const showMore = useLocaleText('see_more')
  const showLess = useLocaleText('show_less')

  const visibleParticipants = participants.slice(0, 7)
  const collapedParticipants = participants.slice(7)

  const handleToggle = () => setShowAll(!showAll)

  return (
    <Stack direction="column" width="100%" spacing="12px">
      {visibleParticipants.map(({ id, date }, index) => {
        const avatar = getAvatarSrc({ id: id, groups: groups, retailUsersObject: retailUsersObject! })
        const participantName = getContextName(id, groups, retailUsersObject!)

        return (
          <Box key={`${id}-${index}`}>
            <ContextInfo id={id} avatar={avatar} name={participantName} date={date} />
          </Box>
        )
      })}
      {participants.length > 7 && (
        <>
          <Collapse isOpen={showAll}>
            {collapedParticipants.map(({ id, date }, index) => {
              const avatar = getAvatarSrc({ id: id, groups: groups, retailUsersObject: retailUsersObject! })
              const participantName = getContextName(id, groups, retailUsersObject!)

              return (
                <Box key={`${id}-${index}`} mb={index !== collapedParticipants.length - 1 ? '12px' : 0}>
                  <ContextInfo id={id} avatar={avatar} name={participantName} date={date} />
                </Box>
              )
            })}
          </Collapse>
          <Button
            type="button"
            variant="ghost"
            aria-expanded={showAll}
            justifyContent="space-between"
            alignItems="center"
            onClick={handleToggle}
            width="100%"
            pt="3px"
          >
            <Text color={colors.greyMain} fontWeight="500">
              {showAll ? showLess : showMore}
            </Text>
            <Icon name={showAll ? 'chevron-up' : 'chevron-down'} />
          </Button>
        </>
      )}
    </Stack>
  )
}
